'use strict';

var Backbone = require('backbone'),
  OrderHistoryCollection,

  OrderHistoryModel = Backbone.Model.extend(),

  OrderHistoryCollection = Backbone.Collection.extend({
    firstFetch: false,
    parse: function(response) {
      return response.data.orders;
    },
    model: OrderHistoryModel
  });

module.exports = OrderHistoryCollection;



// WEBPACK FOOTER //
// ./assets/components/OrderHistory/OrderHistoryCollection.js